import { render, staticRenderFns } from "./Waivers.vue?vue&type=template&id=b3961f8e"
import script from "./Waivers.vue?vue&type=script&lang=js"
export * from "./Waivers.vue?vue&type=script&lang=js"
import style0 from "./Waivers.vue?vue&type=style&index=0&id=b3961f8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports